module.exports = __webpack_public_path__ + "static/listing-management-logo-9834c819052b8cad0e6a2c1d4df667da.svg";